import { MonthlyTradingReportFilter } from "../types";
import { User } from "../../../auth/types";
import { httpWebApi } from "../../../../core/http/httpThunks";
import { getParamsDateString } from "../../../../core/util/functions";

export const getMonthlyDateExcel = (
  user: User,
  filter: MonthlyTradingReportFilter
) => {
  return httpWebApi<Blob>({
    method: "GET",
    responseType: "blob",
    timeout: 60 * 4 * 1000,
    url: "reporting/getmonthlytradingxls",
    params: {
      userid: user.userId,
      option: "D",
      year: filter.year,
      month: filter.month,
    },
  });
};

export default getMonthlyDateExcel;
